import {Params} from '@angular/router';
import {
  DashboardActions,
  GET_ANALYTIC_REPORT_DETAILS_FAIL,
  GET_ANALYTIC_REPORT_DETAILS_SUCCESS,
  GET_DAC6_ANALYTIC_REPORT_DETAILS_FAIL,
  GET_DAC6_ANALYTIC_REPORT_DETAILS_SUCCESS,
  GET_DASHBOARD_REPORT_DETAILS_FAIL,
  GET_DASHBOARD_REPORT_DETAILS_SUCCESS,
  GetAnalyticReportDetailsFail,
  GetAnalyticReportDetailsSuccess,
  GetDac6AnalyticReportDetailsFail,
  GetDac6AnalyticReportDetailsSuccess,
  GetDashboardReportDetailsFail,
  GetDashboardReportDetailsSuccess,
  RESET_ANALYTIC_REPORT,
  RESET_ANALYTIC_REPORT_FAIL,
  RESET_ANALYTIC_REPORT_SUCCESS,
  RESET_DAC6_ANALYTIC_REPORT,
  RESET_DAC6_ANALYTIC_REPORT_FAIL,
  RESET_DAC6_ANALYTIC_REPORT_SUCCESS,
  ResetAnalyticsReportError,
  ResetAnalyticsReportSuccess, ResetDac6AnalyticsReportError, ResetDac6AnalyticsReportSuccess,
  SET_FILTER_SUMMARY_DISPLAY_ITEMS,
  SET_QUERY_PARAMS,
  SET_TAB_ID,
  SetFilterSummaryDisplayItems,
  SetQueryParams,
  SetTabId
} from '../action/dashboard-actions';

export interface IDashboardState {
  tabId: string;
  queryParameters: Params;
  filterSummaryDisplayItems: any[];
  dashboardReportDetails: any;
  analyticReportDetails: any;
  dashboardReportError: any;
  analyticReportError: any;
  dac6AnalyticReportDetails: any;
  dac6AnalyticReportError: any;
  analyticsRefreshData: any;
  analyticsRefreshError: any;
  isAnalyticsResetOnGoing: boolean;
  dac6AnalyticsRefreshData: any;
  dac6AnalyticsRefreshError: any;
  isDac6AnalyticsResetOnGoing: boolean;
}

export const initialState: IDashboardState = {
  tabId: '',
  queryParameters: null,
  filterSummaryDisplayItems: [],
  dashboardReportDetails: null,
  analyticReportDetails: null,
  dashboardReportError: null,
  analyticReportError: null,
  dac6AnalyticReportDetails: null,
  dac6AnalyticReportError: null,
  analyticsRefreshData: null,
  analyticsRefreshError: null,
  isAnalyticsResetOnGoing: false,
  dac6AnalyticsRefreshData: null,
  dac6AnalyticsRefreshError: null,
  isDac6AnalyticsResetOnGoing: false
};

export function dashboardReducer(state: IDashboardState = initialState, action: DashboardActions) {
  switch (action.type) {
    case SET_TAB_ID: {
      const tabId = (action as SetTabId).tabId;
      return {
        ...state,
        tabId: tabId
      }
    }
    case SET_QUERY_PARAMS: {
      const queryParams = (action as SetQueryParams).queryParameters;
      return {
        ...state,
        queryParameters: queryParams
      }
    }
    case SET_FILTER_SUMMARY_DISPLAY_ITEMS: {
      const displayItems = (action as SetFilterSummaryDisplayItems).displayItems;
      return {
        ...state,
        filterSummaryDisplayItems: displayItems
      }
    }
    case GET_DASHBOARD_REPORT_DETAILS_SUCCESS: {
      const reportDetail = (action as GetDashboardReportDetailsSuccess).reportDetails;
      return {
        ...state,
        dashboardReportDetails: reportDetail
      }
   }
    case GET_ANALYTIC_REPORT_DETAILS_SUCCESS: {
      const reportDetail = (action as GetAnalyticReportDetailsSuccess).reportDetails;
      return {
        ...state,
        analyticReportDetails: reportDetail
      }
    }
    case GET_DAC6_ANALYTIC_REPORT_DETAILS_SUCCESS: {
      const reportDetail = (action as GetDac6AnalyticReportDetailsSuccess).reportDetails;
      return {
        ...state,
        dac6AnalyticReportDetails: reportDetail
      }
    }
    case GET_DASHBOARD_REPORT_DETAILS_FAIL: {
      const error = (action as GetDashboardReportDetailsFail).error;
      return {
        ...state,
        dashboardReportError: error
      }
    }
    case GET_ANALYTIC_REPORT_DETAILS_FAIL: {
      const error = (action as GetAnalyticReportDetailsFail).error;
      return {
        ...state,
        analyticReportError: error
      }
    }
    case GET_DAC6_ANALYTIC_REPORT_DETAILS_FAIL: {
      const error = (action as GetDac6AnalyticReportDetailsFail).error;
      return {
        ...state,
        dac6AnalyticReportError: error
      }
    }
    case RESET_ANALYTIC_REPORT :{
      return {
        ...state,
        isAnalyticsResetOnGoing : true,
        analyticsRefreshData: null,
      }
    }
    case RESET_ANALYTIC_REPORT_SUCCESS :{
      const resetData = (action as ResetAnalyticsReportSuccess).response;
      return {
        ...state,
        isAnalyticsResetOnGoing :  false,
        analyticsRefreshData : resetData
      }
    }
    case RESET_ANALYTIC_REPORT_FAIL :{
      const error = (action as ResetAnalyticsReportError).error;
      return {
        ...state,
        isAnalyticsResetOnGoing : false,
        analyticReportError: error
      }
    }
    case RESET_DAC6_ANALYTIC_REPORT :{
      return {
        ...state,
        isDac6AnalyticsResetOnGoing : true,
        dac6AnalyticsRefreshData: null,
      }
    }
    case RESET_DAC6_ANALYTIC_REPORT_SUCCESS :{
      const resetData = (action as ResetDac6AnalyticsReportSuccess).response;
      return {
        ...state,
        isDac6AnalyticsResetOnGoing :  false,
        dac6AnalyticsRefreshData : resetData
      }
    }
    case RESET_DAC6_ANALYTIC_REPORT_FAIL :{
      const error = (action as ResetDac6AnalyticsReportError).error;
      return {
        ...state,
        isDac6AnalyticsResetOnGoing : false,
        dac6AnalyticReportError: error
      }
    }
    default:
      return state;
  }
}
